import React from 'react';
import { Icon } from '../Icon';
import pauseFamilyTabletSrc from '../../assets/images/slide/pause-family-tablet.png';
import styles from './PauseSlideContentV5.css';

const CHECKLIST_ITEMS = [
    'Seven chapters, from childhood to now',
    'Every answer decides the next question',
    'You will not run out of questions'
];

function PauseSlideContentV5() {
    return (
        <div className={styles.form}>
            <div className={styles.imageWrapper}>
                <img src={pauseFamilyTabletSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.content}>
                <div className={styles.headingSection}>
                    <h2 className={styles.heading}>Not another blank page</h2>
                    <p className={styles.description}>A journal asks you to start. We ask the question — and the next one comes from what you just said. You end up telling things you would never have sat down to write.</p>
                </div>
                <ul className={styles.checklist}>
                    {CHECKLIST_ITEMS.map(item => (
                        <li key={item} className={styles.checklistItem}>
                            <Icon name='check' className={styles.checklistIcon} />
                            <span>{item}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export {
    PauseSlideContentV5
};
